import { lazy } from "react";
import { Route } from "react-router-dom";
import UserTypeComponentSplitter from "components/v1/navigation/UserTypeComponentSplitter";
const CertificationsListDiversity = lazy(() => import("./CertificationsListDiversity"));
const CertificationsListVendor = lazy(() => import("./CertificationsListVendor"));


const certificationsRoutes = 

    <Route path="certifications/records-list" element={<UserTypeComponentSplitter diversityComponent={<CertificationsListDiversity />} vendorComponent={<CertificationsListVendor />} />} />;

export default certificationsRoutes;